import { PitchListScope } from "../scopes";
import { createOnboardingAsyncAction } from "./helpers/actionCreators";

export type PitchListData = {
  pitchConcepts: Record<string, unknown>;
};

export enum PitchListActions {
  FETCH_START = "@pitchList/FETCH_START",
  FETCH_COMPLETED = "@pitchList/FETCH_COMPLETED",
  FETCH_ERROR = "@pitchList/FETCH_ERROR",
}

export const pitchListActions = {
  fetchPitchList: createOnboardingAsyncAction(
    PitchListScope,
    PitchListActions.FETCH_START,
    () => ({}),
    PitchListActions.FETCH_COMPLETED,
    (data: PitchListData) => ({ data }),
    PitchListActions.FETCH_ERROR,
    (error: Error) => ({ error })
  ),
};
